import { render, staticRenderFns } from "./Weddingrecords.vue?vue&type=template&id=5ae61281&scoped=true"
import script from "./Weddingrecords.vue?vue&type=script&lang=js"
export * from "./Weddingrecords.vue?vue&type=script&lang=js"
import style0 from "./Weddingrecords.vue?vue&type=style&index=0&id=5ae61281&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae61281",
  null
  
)

export default component.exports